import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconClipboardX",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, l, p, h, a) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--clipboard-x"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Clipboard X",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    i("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.5.5a1 1 0 0 0-1 1H3A1.5 1.5 0 0 0 1.5 3v7A1.5 1.5 0 0 0 3 11.5h6a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 9 1.5h-.5a1 1 0 0 0-1-1h-3Zm3 1h-3v1h3v-1Zm0 2a1 1 0 0 0 1-1H9a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h.5a1 1 0 0 0 1 1h3Z",
      fill: "currentColor"
    }, null, -1),
    i("path", {
      d: "M7.854 5.854a.5.5 0 1 0-.708-.708L6 6.293 4.854 5.146a.5.5 0 1 0-.708.708L5.293 7 4.146 8.146a.5.5 0 1 0 .708.708L6 7.707l1.146 1.147a.5.5 0 1 0 .708-.708L6.707 7l1.147-1.146Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=clipboard-x.js.map
